"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Vendredi",
    "MONDAY": "lundi",
    "SATURDAY": "samedi",
    "SUNDAY": "dimanche",
    "THURSDAY": "jeudi",
    "TUESDAY": "Mardi",
    "WEDNESDAY": "mercredi",
    "and": "et",
    "day_many": "beaucoup",
    "day_one": "jour",
    "day_other": "jours",
    "day_plural": "jours",
    "freeOfCharge": "gratuit",
    "hour_many": "beaucoup",
    "hour_one": "heure",
    "hour_one_plural": "heures",
    "hour_other": "heures",
    "minute": "minute",
    "minute_many": "beaucoup",
    "minute_one": "minute",
    "minute_other": "minutes",
    "ocpiRestrictionsAfterDuration": "Après {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Entre {{minDuration}} et {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Premières {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Quand la consommation d'énergie est supérieure à {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Quand la consommation d'énergie est entre {{minKwh}} et {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Quand la consommation d'énergie est inférieure à {{maxKwh}}",
    "session": "session",
    "theDay_many": "beaucoup",
    "theDay_one": "jour",
    "theDay_other": "jours",
    "theHour_many": "beaucoup",
    "theHour_one": "heure",
    "theHour_other": "heures",
    "theMinute_many": "beaucoup",
    "theMinute_one": "minute",
    "theMinute_other": "minutes"
};
